import store from '@/store';

export const updateLayersToSyncProperty = (layerToSync, property, value) => {
  const layersToSync = store.state.layersToSync;
  const newLayersToSync = layersToSync.map((layer) => {
    if (layer.layerData.id === layerToSync.id) {
      return { ...layer, layerData: { ...layer.layerData, [property]: value } };
    }
    return layer;
  });
  store.commit('setLayersToSync', newLayersToSync);
};

export const isNonAutoLayoutFrame = (layer) => {
  return (
    (layer.layerData.originalType === 'FRAME' && !layer.layerData.layoutMode) ||
    layer.layerData.originalType === 'GROUP'
  );
};

export const isGridLayout = (layer) => {
  return layer.layerData.hasGridInNodeTree;
};

export const isLayerUnsupported = (layer) => {
  return isNonAutoLayoutFrame(layer) || isGridLayout(layer);
};
